import { DefaultLayout } from './DefaultLayout'
import { SidebarLayout } from './SidebarLayout'

export const isNewLayoutApp = (
  process.env.APP === 'dashboard' || process.env.APP === 'demo-dashboard'
)

export const DefaultLayoutComponent = (
  isNewLayoutApp ?
    SidebarLayout :
    DefaultLayout
)
